/**
 * Flash Message Utility
 * Stores one-time messages that persist across page navigation
 * Messages are cleared after being read once
 */

const FLASH_MESSAGE_KEY = 'flash_message';

export const flashMessage = {
  /**
   * Set a flash message to be displayed once
   * @param {string} message - The message to display
   * @param {string} type - Message type: 'info', 'success', 'warning', 'error'
   */
  set: (message, type = 'info') => {
    localStorage.setItem(FLASH_MESSAGE_KEY, JSON.stringify({ message, type }));
  },

  /**
   * Get the flash message and clear it from storage
   * @returns {object|null} - Flash message object with 'message' and 'type' properties, or null if no message
   */
  get: () => {
    const data = localStorage.getItem(FLASH_MESSAGE_KEY);
    if (data) {
      localStorage.removeItem(FLASH_MESSAGE_KEY);
      try {
        return JSON.parse(data);
      } catch (e) {
        return null;
      }
    }
    return null;
  },

  /**
   * Clear any existing flash message
   */
  clear: () => {
    localStorage.removeItem(FLASH_MESSAGE_KEY);
  },

  /**
   * Check if a flash message exists without clearing it
   * @returns {boolean}
   */
  exists: () => {
    return localStorage.getItem(FLASH_MESSAGE_KEY) !== null;
  }
};

export default flashMessage;
